import { schAloftPrice, schValueType } from '@aloft/toolkit-shared';

import { z } from 'zod';

export const schReconciliationForm = z
  .object({
    totalCostToCure: schAloftPrice.optional(),
    totalCostToCureCommentary: z.string().optional(),
    opinionOfMarketValue: schAloftPrice.optional(),
    opinionOfAfterRepairValue: schAloftPrice.optional(),
    totalRenovationBudget: schAloftPrice.optional(),
    reconciliationCommentary: z.string().optional(),
    aivReconciliationCommentary: z.string().optional(),
    arvReconciliationCommentary: z.string().optional(),
    highestAndBestUseCommentary: z.string().optional(),
    revisionCommentary: z.string().optional(),
    alternativeComparablesCommentary: z.array(z.string()).optional(),
    feasibilityCommentary: z.string().optional(),
    aivDiscrepancyCommentary: z.string().optional(),
    arvDiscrepancyCommentary: z.string().optional(),
    hasAivDiscrepancy: z.boolean().optional(),
    hasArvDiscrepancy: z.boolean().optional(),
    valueTypes: z.array(schValueType).optional(),
  })
  .superRefine((value, ctx) => {
    if (value.hasAivDiscrepancy && !value.aivDiscrepancyCommentary?.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Required',
        path: ['aivDiscrepancyCommentary'],
      });
    }

    if (value.hasArvDiscrepancy && !value.arvDiscrepancyCommentary?.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Required',
        path: ['arvDiscrepancyCommentary'],
      });
    }
  });
export type ReconciliationFormOutput = z.infer<typeof schReconciliationForm>;
export type ReconciliationForm = typeof schReconciliationForm;
